import { IconButton } from '@material-ui/core'
import { ReactComponent as BellSvg } from '_icons/ui/bell.svg'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import { useAppRunningContext } from 'features/EmbeddedRh24/useAppRunningContext'
import { useAppSelector } from 'store/configureStore'
import { isEqual } from 'lodash'
import i18n from 'i18next'

export const BeamerNotificationButton = (props: { style: CSSProperties }) => {
  const { withinIframe } = useAppRunningContext()
  const beamerEnabled = useAppSelector(
    (state) => state.user?.organizationContext?.showBeamerNotifications
  )
  const userProfile = useAppSelector((state) => state.user?.profile, isEqual)

  const beamerScriptTag = document.getElementById('beamer-script')

  if (withinIframe && !beamerEnabled) {
    if (beamerScriptTag) {
      beamerScriptTag.remove()
    }
    return null
  }

  window['beamer_config'] = {
    product_id: process.env.REACT_APP_BEAMER_PRODUCT_ID,
    filter: !withinIframe ? 'portal' : undefined, // users not in portal should receive portal messages and messages without segmentation
    force_filter: withinIframe ? 'portal' : undefined, // users in the portal shall receive only messages with portal segmentation
    display: 'right',
    selector: 'app-notification-button',
    multi_user: true,
    user_id: userProfile?.email,
    user_email: userProfile?.email,
    user_firstname: userProfile?.firstName,
    user_lastname: userProfile?.lastName,
    language: i18n.language,
    first_visit_unread: withinIframe ? 0 : 1,
  }

  if (!document.getElementById('beamer-script')) {
    const scriptTag = document.createElement('script')
    scriptTag.id = 'beamer-script'
    scriptTag.src = 'https://app.getbeamer.com/js/beamer-embed.js'
    scriptTag.type = 'text/javascript'

    document.body.appendChild(scriptTag)
  }

  if (window['Beamer']) {
    window['Beamer'].update(window['beamer_config'])
  }

  return (
    <IconButton
      id="app-notification-button"
      color="inherit"
      size="small"
      style={props.style}
    >
      <BellSvg
        className="MuiSvgIcon-root"
        style={{ width: '100%', height: '100%' }}
      />
    </IconButton>
  )
}
